import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { EventSharedService } from 'src/app/shared/services/event-shared.service';
import { AtualizacoesAudit } from '../../models/atualizacoes-audit';
import { IndicadoresAnalise } from '../../models/indicadores-analise.model';
import { ProjetoCadastro } from '../../models/projeto-cadastro.model';
import { IndicadoresAnaliseService } from '../../services/indicadores-analise.service';
import { NavigationService } from '../../services/navigation.service';
import { PesquisaGeralService } from '../../services/pesquisa-geral.service';

@Component({
  selector: 'app-detalhe-projeto-indicadores-analise-edit',
  templateUrl: './detalhe-projeto-indicadores-analise-edit.component.html',
  styleUrls: ['./detalhe-projeto-indicadores-analise-edit.component.scss']
})
export class DetalheProjetoIndicadoresAnaliseEditComponent extends BaseFormComponent<IndicadoresAnalise> implements OnInit {

  idProjeto: number;
  idIndicador: number;
  analise: IndicadoresAnalise;
  infoProjeto: ProjetoCadastro;
  actionLabel: string = 'Nova';
  list: any;
  listUsuario: any[];
  audit: AtualizacoesAudit;

  constructor(
    private myService: IndicadoresAnaliseService,
    public activatedRoute: ActivatedRoute,
    private navigation: NavigationService,
    private pesquisaGeralService: PesquisaGeralService,
  ) {
    super(activatedRoute)
  }

  ngOnInit(): void {
    this.pesquisaGeralService.info.subscribe(info => {
      this.infoProjeto = info;
      this.idProjeto = this.infoProjeto.id;
      this.list = this.activatedRoute.snapshot.data['list'];
      if (!this.entity?.id && this.activatedRoute.snapshot.queryParams['ind_id']) {
        this.idIndicador = this.activatedRoute.snapshot.queryParams['ind_id'];
      }
      this.initForm();
      this.loaded();
    });
  }

  initForm() {
    this.form = new FormGroup({
      ind_id: new FormControl(null),
      description: new FormControl('', [Validators.required]),
      ind_analysis_stat_id: new FormControl(null, [Validators.required]),
    });

    if (this.entity) {
      this.actionLabel = 'Editar';
      this.form.patchValue(this.entity);

      this.audit = {
        ind_analysis_id: this.entity.id
      };
    }
  }

  voltar() {
    if (this.entity?.id) {
      this.navigation.back(['projetos', 'projeto', this.idProjeto, 'indicadores', this.entity?.ind_id]);
    } else {
      this.navigation.back(['projetos', 'projeto', this.idProjeto, 'indicadores', this.idIndicador]);
    }
  }

  getDataCreate(): IndicadoresAnalise {
    let data: IndicadoresAnalise;
    data = Object.assign({}, data, this.form.value);

    if (!this.entity?.id && this.idIndicador) {
      data.ind_id = this.idIndicador;
    }

    return data;
  }

  salvar(): void {
    if (this.form.valid) {
      this.loading();
      
      if (this.entity?.id) {
        this.addSub(
          this.myService.update(this.getDataCreate(), this.entity?.id).subscribe({
            next: (res) => {
              this.msgSuccess('Análise alterada com sucesso!');
              EventSharedService.get('auditRefresh').emit();
              this.loaded();
            },
            error: (error) => {
              this.msgError(error?.error?.message);
              this.loaded();
            },
          })
        );
      } else {
        this.addSub(
          this.myService.create(this.getDataCreate()).subscribe({
            next: (res) => {
              this.confirmation().subscribe(() => {
                this.navigation.replace(['projetos', 'projeto', this.idProjeto, 'indicadores', 'analise', res.id, 'editar']);
              })
              this.loaded();
            },
            error: (error) => {
              this.msgError(error?.error?.message);
              this.loaded();
            },
          })
        );
      }
    }
    else {
      this.markAsDirty();
    }
  }
}
